export default __webpack_public_path__ + "static/media/analytics-anabot.35ccb505.svg";